import React from "react";
/*eslint-disable */
import icon from "../../assets/03_Producto/Webp/Group.webp";

interface ServiciosItemComponentProps {
  item: any;
  index: number;
}

declare const window: any;
const ServiciosItemComponent: React.FC<ServiciosItemComponentProps> = ({
  item,
  index
}) => {

  const [isVisible, setIsVisible] = React.useState(false);
  const ref = React.useRef<HTMLDivElement | null>(null);
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else if (entry.boundingClientRect.top > 0) {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div ref={ref} key={index} className={`contenido-servicios-posventa-finanzas-container ${item.format === "left" ? "anormal" : ""} ${isVisible ? "visible" : ""}`}>
      <div className="img-contenido-servicios-posventa-finanzas-container">
        <img 
          src={`https://manager.hyundaicolombia.co/${item?.media?.url}`}
          alt={item?.title ? item.title : "Imagen del servicio"} 
        />
      </div>
      <div className="text-contenido-servicios-posventa-finanzas-container">
        <div className="title">{item?.title}</div>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: item?.description }}
        ></div>
        {item.enable_button ? (
          <a href={item?.button_url} className="btn">
            Ver más
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default ServiciosItemComponent;
